// obBuilderService — thin client wrapper over the ob-builder-price edge function.
// Mirrors the loProspectService invoke pattern. The edge function returns some
// business outcomes as non-2xx (rate_limited=429, disabled=403, controls=503),
// so we recover the JSON body from the FunctionsHttpError context.

import { supabase } from '@/utils/supabase';
import type {
  ObBuilderIdentityMode,
  ObBuilderResponse,
  ObScenario
} from '@/components/admin/ob-builder/types';

export interface ObBuilderRequest {
  mode: 'validate' | 'live';
  anchor: 'price' | 'rate';
  identityMode: ObBuilderIdentityMode;
  includePii?: boolean;
  scenario: Partial<ObScenario>;
}

export async function runObBuilder(req: ObBuilderRequest): Promise<ObBuilderResponse> {
  const { data, error } = await supabase.functions.invoke('ob-builder-price', { body: req });

  if (error) {
    // supabase-js FunctionsHttpError carries the raw Response on `.context`.
    const ctx = (error as { context?: unknown }).context;
    let payload: unknown = null;
    if (ctx && typeof (ctx as Response).json === 'function') {
      try {
        payload = await (ctx as Response).json();
      } catch {
        /* body was not JSON */
      }
    }
    if (payload && typeof payload === 'object') {
      const p = payload as ObBuilderResponse & { error?: string };
      // A business outcome (e.g. rate_limited) carries a `status` — surface it as a
      // normal result. A pure error envelope (disabled / config / controls_unavailable
      // / bad_request / unauthorized) has no status — throw its message so the console
      // shows it loudly instead of rendering nothing.
      if (p.status) {
return p;
}
      throw new Error(p.message || p.error || 'OB Builder request failed');
    }
    throw error;
  }

  return data as ObBuilderResponse;
}
